import { defineStore } from 'pinia';

export const useDialogStore = defineStore('dialogStore', {
    state: () => ({ modals: {} as Record<string, boolean> }),
    actions: {
        initializeModal(id: string): void {
            this.modals[id] = false;
        },

        open(id: string = 'default'): void {
            const modal = this.getById(id);
            if (modal !== undefined) {
                this.modals[modal] = true;
            }
        },

        close(id: string = 'default'): void {
            const modal = this.getById(id);
            if (modal !== undefined) {
                this.modals[modal] = false;
            }
        },

        getById(id: string): string | undefined {
            const modalKeys = Object.keys(this.modals);
            const foundModal = modalKeys.find(key => key === id);

            return foundModal;
        },
    },
});
